<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          <span *ngIf="isChangePassword">Changer mot de passe</span>
          <span *ngIf="!isChangePassword">Créer mot de passe</span>
        </h1>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <form class="col-md-6 pb-40 form-area" [formGroup]="form" (ngSubmit)="onSubmitForm()">
        <div class="form-group" *ngIf="isChangePassword">
          <label for="oldPassword">Ancien mot de passe</label>
          <input type="password" class="form-control" id="oldPassword" formControlName="oldPassword">
        </div>
        <div class="form-group">
          <label for="newPassword">Nouveau mot de passe</label>
          <input type="password" class="form-control" id="newPassword" formControlName="newPassword">
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirmer mot de passe</label>
          <input type="password" class="form-control" id="confirmPassword" formControlName="confirmPassword">
        </div>
        <button type="submit" class="primary-btn text-white mb-4" [disabled]="form.invalid" *ngIf="(!isLoading) && (isChangePassword)">Changer</button>
        <button type="submit" class="primary-btn text-white mb-4" [disabled]="form.invalid" *ngIf="(!isLoading) && (!isChangePassword)">Créer</button>
        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez patienter...</p>
        <div class="form-group" *ngIf="(!isChangePassword) && (typeUser == 'candidat')">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="(!isChangePassword) && (typeUser == 'consultant')">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="(!isChangePassword) && (typeUser == 'entreprise')">
          <label>Retour à la page de <a [routerLink]="['/connexion']">connexion</a></label>
        </div>
        <div class="form-group" *ngIf="(!isChangePassword) && (typeUser == 'admin')">
          <label>Retour à la page de <a [routerLink]="['/admin']">connexion</a></label>
        </div>
      </form>
    </div>
  </div>
</section>
<!-- End service Area -->